import { isDefined } from './type-guard';
export function omit(oriObject, keysToOmit) {
    const result = Object.assign({}, oriObject);
    keysToOmit.forEach((key) => 
    // @ts-expect-error
    delete result[key]);
    return result;
}
export function pick(oriObject, keysToPick) {
    const result = {};
    keysToPick.forEach((key) => {
        const value = oriObject[key];
        if (isDefined(value)) {
            result[key] = value;
        }
    });
    return result;
}
//# sourceMappingURL=object.js.map